export default __webpack_public_path__ + "static/media/bank.afc5fe37.svg";